import { Component, Input, OnInit } from '@angular/core';
import { IStudent } from '../model/student';

@Component({
    selector: 'app-studentInfo',
    templateUrl: 'studentInfo.component.html'
})

export class StudentInfoComponent implements OnInit {
    mask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    @Input() student: IStudent;
    constructor() { }

    ngOnInit() { }
}